const getters = {
  processing: (state) => state.processing,
  bulkProcessing: (state) => state.bulkProcessing,
  penalties: (state) => state.penalties,
};

export default getters;
